import { Descriptions, List } from "antd";
import { array, object } from "prop-types";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { ConditionalAccessName } from "./ConditionalAccessName";

export const ConditionalAccessViewer = ({ conditionalAccess, formLookup }) => {
  const intl = useIntl();

  const getDisplay = useCallback(
    (propertyName, id) => {
      if (formLookup?.[propertyName]?.[id]) return formLookup[propertyName][id];
      return id;
    },
    [formLookup]
  );

  const getArrayDisplay = useCallback(
    (propertyName, ids, emptyMeansAll) => {
      if (ids) {
        return ids.map((id) => getDisplay(propertyName, id)).join(", ");
      } else if (emptyMeansAll) {
        return intl.formatMessage({
          id: "profile.conditionalAccessViewer.productCategoriesAll",
        });
      }
      return "";
    },
    [getDisplay, intl]
  );

  return (
    <List
      itemLayout="horizontal"
      dataSource={conditionalAccess}
      renderItem={(item) => (
        <List.Item>
          <Descriptions column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 4, xxl: 4 }}>
            <Descriptions.Item
              label={intl.formatMessage({
                id: "profile.conditionalAccessViewer.adGroupName",
              })}
            >
              <ConditionalAccessName id={item.adGroupName} />
            </Descriptions.Item>
            <Descriptions.Item
              label={intl.formatMessage({
                id: "profile.conditionalAccessViewer.projectTypes",
              })}
            >
              {getArrayDisplay("projectType", item.projTypes, false)}
            </Descriptions.Item>
            <Descriptions.Item
              label={intl.formatMessage({
                id: "general.productCategories",
              })}
            >
              {getArrayDisplay("productCategory", item.prodCats, true)}
            </Descriptions.Item>
            <Descriptions.Item
              label={intl.formatMessage({
                id: "profile.conditionalAccessViewer.company",
              })}
            >
              {item.compCode}
            </Descriptions.Item>
          </Descriptions>
        </List.Item>
      )}
    />
  );
};

ConditionalAccessViewer.propTypes = {
  conditionalAccess: array,
  formLookup: object,
};
